<template>
  <transition name="cube-picker-fade">
    <cube-popup
      v-show="isVisible"
      ref="myPopup"
      type="select-tree-pop"
      :center="false"
      :mask-closable="maskClosable || true"
      position="bottom"
      @touchmove.prevent
      @mask-click="maskClick"
    >
      <transition name="cube-picker-move">
        <div
          v-show="isVisible"
          ref="myPopupPanel"
          class="cube-picker-panel cube-safe-area-pb"
          @click.stop
        >
          <div class="cube-picker-choose border-bottom-1px">
            <span
              class="cube-picker-cancel"
              @click="cancel"
            >{{ _cancelTxt }}</span>
            <span v-if="data.fieldname">{{ data.fieldname }}</span>
            <span
              class="cube-picker-confirm"
              @click="confirm"
            >{{ _confirmTxt }}</span>
            <div class="cube-picker-title-group">
              <h1
                class="cube-picker-title"
                v-html="title"
              />
              <h2
                v-if="subtitle"
                class="cube-picker-subtitle"
                v-html="subtitle"
              />
            </div>
          </div>

          <div class="cube-picker-content">
            <div
              ref="wrapper"
              class="wrapper"
            >
              <cell-list
                :data="options"
                :multiple="true"
                @change="handleChangeChoose"
              >
                <template v-slot:item="{ data }">
                  <div
                    class="item"
                    :class="{ 'checked': data.checked }"
                  >
                    <i
                      v-if="data.checked"
                      class="iconfont iconicon-test19 fs-blue"
                    />
                    <i
                      v-if="!data.checked"
                      class="iconfont iconicon-test13"
                    />
                    <span class="name">{{ data.name }}</span>
                  </div>
                </template>
              </cell-list>
            </div>
          </div>
        </div>
      </transition>
    </cube-popup>
  </transition>
</template>

<script>
// import CubePicker from 'cube-ui'
import BScroll from 'better-scroll'
import CellList from '@/components/mobile/CellList'

const COMPONENT_NAME = 'cube-select-tree'
const EVENT_CANCEL = 'cancel'
const EVENT_CONFIRM = 'confirm'

const DEFAULT_OPTIONS = {
  observeDOM: true,
  click: true,
  probeType: 1,
  scrollbar: false,
  pullDownRefresh: false,
  pullUpLoad: false
}
export default {
  name: COMPONENT_NAME,
  // extends: CubePicker,
  components: {
    CellList
  },
  props: {
    options: {
      type: [Object, Array],
      default: () => { }
    },
    defaultValue: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    cancelTxt: {
      type: String,
      default: ''
    },
    confirmTxt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isVisible: false,
      data: this.options,
      selectList: [],
      result: []
    }
  },
  computed: {
    _cancelTxt () {
      return this.cancelTxt || this.$t('message["896"]')
    },
    _confirmTxt () {
      return this.confirmTxt || this.$t('message["915"]')
    }
  },
  watch: {
    isVisible (val) {
      if (val) {
        this.initScroll()
      } else {
        this.destroy()
      }
    }
  },
  created () {
  },
  mounted () {
    /* this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.wrapper, DEFAULT_OPTIONS)
    }) */
  },
  beforeDestroy () {
    this.destroy()
  },
  methods: {
    handleChangeChoose (item) {
      console.log(item)
    },
    closest (el, selector) {
      var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector

      while (el) {
        if (matchesSelector.call(el, selector)) {
          break
        }

        el = el.parentElement
      }

      return el
    },
    initScroll () {
      let options = {
        ...DEFAULT_OPTIONS,
        scrollY: true,
        click: true
      }
      this.$nextTick(() => {
        let $wrapper = this.$refs.wrapper
        let $children = $wrapper.children && $wrapper.children[0]
        let $el = this.closest($wrapper, '.cube-picker-panel')
        let h = 480

        if ($children.clientHeight > 480) {
          h = 480
          $el.style.height = h + 'px'
          $wrapper.style.height = h - 60 + 'px'
        } else {
          h = $children.clientHeight
          $el.style.height = h + 60 + 'px'
          $wrapper.style.height = h + 'px'
        }

        setTimeout(() => {
          this.scroll = new BScroll($wrapper, options)
        }, 1000)
      })
    },
    disable () {
      this.scroll && this.scroll.disable()
    },
    enable () {
      this.scroll && this.scroll.enable()
    },
    refresh () {
      this._calculateMinHeight()
      this.scroll && this.scroll.refresh()
    },
    destroy () {
      this.scroll && this.scroll.destroy()
      this.scroll = null
    },
    show () {
      this.isVisible = true
    },
    hide () {
      this.isVisible = false
    },
    maskClick () {
      this.maskClosable && this.cancel()
    },
    cancel () {
      this.hide()
      this.$emit(EVENT_CANCEL)
    },
    confirm () {
      this.hide()

      // this.$emit('confirm', this.result)
      this.$emit(EVENT_CONFIRM, this.result)
    }
  }
}
</script>

<style lang="scss" scoped>
.cube-picker-panel {
  width: 100%;
  max-height: 480px;
  text-align: left;
  // overflow: hidden;
}
.cube-picker-content {
  top: 0;
}
.wrapper {
  width: 100%;
  // height: 213px;
  overflow: hidden;
}
::v-deep .item {
  padding: 0 17px !important;
  justify-content: flex-start !important;
  .name {
    margin-left: 5px;
    font-size: 16px;
    width: calc(100% - 20px);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .iconfont {
    color: $gray3;
  }
  .fs-blue {
    color: $blue;
  }
}
</style>
